import { render, staticRenderFns } from "./AfterSales.vue?vue&type=template&id=59b2b92c&scoped=true"
import script from "./AfterSales.vue?vue&type=script&lang=js"
export * from "./AfterSales.vue?vue&type=script&lang=js"
import style0 from "./AfterSales.vue?vue&type=style&index=0&id=59b2b92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b2b92c",
  null
  
)

export default component.exports